import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=5a955277"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/applications/abenity.com-cb0cd5ae/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a955277')) {
      api.createRecord('5a955277', component.options)
    } else {
      api.reload('5a955277', component.options)
    }
    module.hot.accept("./Categories.vue?vue&type=template&id=5a955277", function () {
      api.rerender('5a955277', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/vue-components/Categories.vue"
export default component.exports